import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Play, X, ExternalLink } from 'lucide-react';
export function ClosingScreen() {
  const [showVideo, setShowVideo] = useState(false);
  return <section className="min-h-screen flex flex-col items-center justify-center bg-white px-6 py-20" data-id="element-147">
      <div className="max-w-4xl w-full mx-auto flex flex-col items-center" data-id="element-148">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-bold text-slate-900 text-center mb-4" data-id="element-149">
          See it in action
        </motion.h2>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="text-lg text-slate-400 text-center mb-12 max-w-xl" data-id="element-150">
          Experience the Chronic Hand Eczema Snak — live and interactive.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3,
        duration: 0.6
      }} className="w-full relative" data-id="element-151">
          <div className="absolute -inset-3 bg-gradient-to-br from-purple-100 to-emerald-100 rounded-3xl blur-xl opacity-60" data-id="element-152" />

          <div className="relative rounded-2xl overflow-hidden shadow-xl" data-id="element-153">
            {/* Screenshot as background */}
            <img src="https://cdn.magicpatterns.com/uploads/jgFs298mhfNuKUJFMW7Kzq/Screenshot_2026-04-15_at_20.59.08.png" alt="Chronic Hand Eczema Snak — live on the website" className="w-full h-auto block" data-id="element-154" />

            <AnimatePresence data-id="element-155">
              {showVideo && <motion.div key="video-overlay" initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1
            }} exit={{
              opacity: 0,
              scale: 0.9
            }} transition={{
              duration: 0.3
            }} className="absolute inset-0 flex items-center justify-center bg-black/60 backdrop-blur-sm z-20" data-id="element-156">
                  <div className="relative w-full max-w-3xl mx-4 rounded-xl overflow-hidden shadow-2xl" style={{
                aspectRatio: '16/9'
              }} data-id="element-157">
                    <button onClick={() => setShowVideo(false)} className="absolute top-3 right-3 z-30 w-9 h-9 rounded-full bg-black/60 hover:bg-black/80 flex items-center justify-center text-white transition-colors" data-id="element-158">
                      <X size={18} data-id="element-159" />
                    </button>
                    <iframe src="https://player.snakker.io/review/u4vPgCfOyEqBIrg7LoCb" className="w-full h-full absolute inset-0" allow="autoplay; fullscreen" style={{
                  border: 'none'
                }} data-id="element-160" />
                  </div>
                </motion.div>}
            </AnimatePresence>

            {/* Clickable overlay — no extra play button since the screenshot already has one */}
            {!showVideo && <div className="absolute inset-0 cursor-pointer" onClick={() => setShowVideo(true)} data-id="element-161" />}
          </div>
        </motion.div>

        {/* Direct link */}
        <motion.a href="https://player.snakker.io/review/u4vPgCfOyEqBIrg7LoCb" target="_blank" rel="noopener noreferrer" initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.8
      }} className="mt-8 inline-flex items-center gap-2 px-6 py-3 bg-purple-600 text-white font-semibold rounded-full shadow-lg shadow-purple-500/20 hover:bg-purple-700 transition-colors" data-id="element-162">
          <span data-id="element-163">Open Snak in new tab</span>
          <ExternalLink size={16} data-id="element-164" />
        </motion.a>
      </div>
    </section>;
}